import React, { forwardRef, ReactNode } from 'react';
import { MenuItem, MenuItemProps, useStyleConfig } from '@chakra-ui/react';

interface Props extends Omit<MenuItemProps, `css`> {
  children: ReactNode;
}

export const DropdownItem = forwardRef<HTMLButtonElement, Props>(
  ({ children, ...props }, ref): JSX.Element => {
    const styles = useStyleConfig(`DropdownItem`);

    return (
      <MenuItem ref={ref} sx={styles} {...props}>
        {children}
      </MenuItem>
    );
  }
);
export type { Props as DropdownItemProps };
